import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BACKEND_URL } from "../../../config";

function ViewProduct() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [viewProduct, setViewProduct] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => { fetchProducts(); }, []);

  const fetchProducts = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api.php?module=product`);
      const result = await res.json();
      if (result.success) setProducts(result.data);
      else setProducts([]);
    } catch (err) { setProducts([]); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;
    try {
      const res = await fetch(`${BACKEND_URL}/api.php?module=product`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const result = await res.json();
      if (result.success) {
        alert("Deleted Successfully");
        setProducts((prev) => prev.filter((p) => p.id !== id));
      } else alert(result.message || "Delete failed");
    } catch (err) { console.log(err); }
  };

  const safeJSON = (data) => {
    if (!data) return [];
    if (typeof data === "string") { try { return JSON.parse(data); } catch { return []; } }
    return data;
  };

  const filteredProducts = products.filter(
  (p) =>
    p.productName?.toLowerCase().includes(search.toLowerCase()) ||
    p.categoryName?.toLowerCase().includes(search.toLowerCase())
);

  // body scroll band
  useEffect(() => {
    if (viewProduct) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => { document.body.style.overflow = ""; };
  }, [viewProduct]);

  return (
    <div className="admin-page">

      {/* CHANGE: inline style hata kar "page-header-bar" class lagayi - mobile pe stack hoga */}
      <div className="page-header-bar">
        <h2>View Products</h2>

        <input
          type="text"
          className="page-search-input"
          placeholder="Search Product or Category..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="admin-table">
        <table>
          <thead>
            <tr>
              <th>Name</th><th>Category</th><th>Image</th><th>Status</th><th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.map((p) => (
              <tr key={p.id}>
                <td>{p.productName}</td>
                <td>{p.categoryName}</td>
                <td>{p.image && <img src={p.image.startsWith("http") ? p.image : `${BACKEND_URL}/${p.image}`} alt="" />}</td>
                <td>{p.status}</td>
                <td className="action-btns">
                  <button className="admin-btn view" onClick={() => setViewProduct(p)}>View</button>
                  <button className="admin-btn edit" onClick={() => navigate(`/admin/products/edit/${p.id}`)}>Edit</button>
                  <button className="admin-btn delete" onClick={() => handleDelete(p.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {viewProduct && (
        <div className="vm-overlay" onClick={() => setViewProduct(null)}>
          <div className="vm-box" onClick={(e) => e.stopPropagation()}>

            <div className="vm-header">
              <div className="vm-header-left">
                <span className="vm-header-title">Product Details</span>
              </div>
              <button className="vm-close-btn" onClick={() => setViewProduct(null)}>✕</button>
            </div>

            <div className="vm-scroll">

              <div className="vm-top-row">
                {viewProduct.image && (
                  <div className="vm-img-box">
                    <img src={viewProduct.image.startsWith("http") ? viewProduct.image : `${BACKEND_URL}/${viewProduct.image}`} alt="" />
                  </div>
                )}
                <div className="vm-top-info">
                  <p className="vm-product-name">{viewProduct.productName}</p>
                  <p className="vm-product-sub">{viewProduct.categoryName} · SKU: {viewProduct.sku}</p>
                  <span className={`vm-badge ${viewProduct.status === "Active" ? "vm-badge-active" : "vm-badge-inactive"}`}>
                    {viewProduct.status}
                  </span>
                </div>
              </div>

              <div className="vm-info-grid">
                <div className="vm-info-item"><span className="vm-label">Slug</span><span className="vm-value">{viewProduct.slug}</span></div>
                <div className="vm-info-item"><span className="vm-label">Date</span><span className="vm-value">{viewProduct.date}</span></div>
                <div className="vm-info-item"><span className="vm-label">Manufacturer</span><span className="vm-value">{viewProduct.manufacturer}</span></div>
                <div className="vm-info-item"><span className="vm-label">Ship Time</span><span className="vm-value">{viewProduct.shipTime}</span></div>
                <div className="vm-info-item vm-full"><span className="vm-label">Composition</span><span className="vm-value">{viewProduct.composition}</span></div>
              </div>

              <div className="vm-section">
                <p className="vm-section-title">Pack Pricing</p>
                <div className="vm-pack-grid">
                  {safeJSON(viewProduct.packPricing).map((item, idx) => (
                    <div key={idx} className="vm-pack-card">
                      <p className="vm-pack-size">{item.packSize} {item.unit}</p>
                      <p className="vm-pack-price">€{item.price}</p>
                      <p className="vm-pack-unit">€{item.unitPerPrice}/tab</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="vm-section">
                <p className="vm-section-title">Keywords</p>
                <div className="vm-tags">
                  {viewProduct.keywords
                    ? viewProduct.keywords.split(",").map((k, i) => <span key={i} className="vm-tag">{k.trim()}</span>)
                    : "-"}
                </div>
              </div>

              <div className="vm-section">
                <p className="vm-section-title">FAQ</p>
                {safeJSON(viewProduct.faq).map((f, i) => (
                  <div key={i} className="vm-faq-item">
                    <p className="vm-faq-q">Q: {f.question}</p>
                    <p className="vm-faq-a">A: {f.answer}</p>
                  </div>
                ))}
              </div>

            </div>

            <div className="vm-footer">
              <button className="vm-footer-edit" onClick={() => { navigate(`/admin/products/edit/${viewProduct.id}`); setViewProduct(null); }}>Edit</button>
              <button className="vm-footer-delete" onClick={() => { handleDelete(viewProduct.id); setViewProduct(null); }}>Delete</button>
              <button className="vm-footer-close" onClick={() => setViewProduct(null)}>Close</button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}

export default ViewProduct;
